import React from 'react';
import { Loader2 } from 'lucide-react';

interface TranscriptInlineProps {
    isOpen: boolean;
    transcript: string | null;
    isLoading: boolean;
    error?: string | null;
    statusText?: string;
    onRetry?: () => void;
    onRecover?: () => void;
    sending?: boolean;
}

const TranscriptInline: React.FC<TranscriptInlineProps> = ({
    isOpen, transcript, isLoading, error, statusText, onRetry, onRecover, sending
}) => {
    if (!isOpen) return null;

    return (
        <div className="mt-1.5 border-t border-line pt-1.5">
            {isLoading && !transcript && !error && (
                <div className="flex items-center gap-1.5 text-ink-muted text-xs py-1">
                    <Loader2 size={12} className="animate-spin" />
                    <span>{statusText ?? 'Transcribing...'}</span>
                </div>
            )}
            {error && (
                <p className="text-red-500 text-xs py-1">{error}</p>
            )}
            {!isLoading && statusText && !transcript && !error && (
                <p className="text-ink-muted text-xs py-1" role="status">{statusText}</p>
            )}
            {onRetry && (
                <button type="button" disabled={sending} onClick={onRetry} className="text-xs text-brand-ink underline">
                    Retry transcription
                </button>
            )}
            {onRecover && (
                <button type="button" disabled={sending} onClick={onRecover} className="ml-2 text-xs text-brand-ink underline">
                    Check existing request
                </button>
            )}
            {transcript && (
                <p className="text-ink-muted-strong text-xs whitespace-pre-wrap leading-relaxed">{transcript}</p>
            )}
        </div>
    );
};

export default TranscriptInline;
